import React, { useCallback } from "react";
import ConfirmModal from "../../organisms/confirm-modal/ConfirmModal";

import useAPIRequest from "../../../hooks/useAPIRequest";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onComplete: () => Promise<void>;
}

function UploadResultsModal({ isOpen, onClose, onComplete }: Props) {
  const [{ inProgress, error }, doAPIRequest] = useAPIRequest<void>(
    onComplete,
    null,
  );

  const handleConfirm = useCallback(() => {
    doAPIRequest(onComplete);
  }, [doAPIRequest, onComplete]);

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={handleConfirm}
      confirmInProgress={inProgress}
      title={"Confirm Upload Results"}
      description={
        <>
          Uploading results will override any results that have been generated
          using the Excel Model. This should only be done if using the AWS
          Model. Press ok continue
        </>
      }
      confirmTitle="Ok"
      error={error && error.message}
      warning
    />
  );
}

export default UploadResultsModal;
